<template>
  <div style="position: relative; min-height: calc(100vh - 160px)">
    <div>
      <div class="flex-x-center" slot="header" style="height: 4em">
        <div
          class="text-bold text-olive text-xl flex-x-center"
          style="margin-left: 0; width: 100%"
        >
          {{ singleData.docName || "发货单详情" }}
        </div>
        <el-button class="margin-right-xs" @click="backHome" size="small"
          >返回首页</el-button
        >
      </div>
    </div>
    <hr />
    <!-- 操作栏 -->
    <div class="actionField" style="margin-bottom: 10px">
      <label>入库单号 </label>
      <span style="cursor: pointer" class="span">{{
        singleData.purchasesReceiptDocNumber
      }}</span>
      <label class="turnToPointer">全局搜索码 </label>
      <span class="span turnToPointer">{{ singleData.globalSearchNumber }}</span>
      <label>入库日期 </label>
      <span class="span">{{ formatDate(singleData.baseEntranceHomeTime) }}</span>
      <label>供应商名称 </label>
      <span class="span">{{ singleData.baseSupplierName }}</span>
      <label>供应商编号 </label>
      <span class="span">{{ singleData.baseSupplierNumber }}</span>
      <label>仓库 </label>
      <span class="span">{{ singleData.baseWarehouseWareName }}</span>
      <label>超量入库模式 </label>
      <span class="span">{{
        singleData.excessiveInventoryMode == 1 ? "作为赠品" : "正常对账"
      }}</span>
    </div>
    <!-- 内容 -->
    <div>
      <myTable
        :overflow="true"
        :id="'myTableOne'"
        :columnType="'columnIndex'"
        @cellClickEvent="cellClickEvent"
        :list="itemList"
        :titleList="titleList"
        :tableBtnList="itemTableBtnList"
        @resizableChange="resizableChange"
        @excelOpen="excelOpen"
        @excelSuccess="excelSuccess"
        :dialogStatus="1"
        ref="myTableOne"
      ></myTable>
    </div>
  </div>
</template>
<script>
import {
  subFloat,
  mulFloat,
  accAdd,
  year,
  month,
  day,
  _debounce,
  getCurrentTime,
  selcetSetting,
  updateSetting,
  customMenu
} from '@/utils/myUtils';
import { pmgtPurchasesReceiptDoc_cooperativeSupplierPurchasesReceiptDocView } from '@/api/myController/purchase';
export default {
  components: {},
  props: {
    getDisplay: {
      type: Number,
      default: 0
    },
    sysEntityExtDto: {
      default: () => ({})
    },
    singleData: {
      default: () => ({})
    },
    itemList: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    },
    // 页面传进来判断的值
    routeType: {
      type: Array,
      default: undefined
    },
    // 页面传进来的值
    routeQuery: {
      default: () => ({})
    },
    homeIndex: {
      type: Number,
      default: false
    },
    modelType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      // -----------------------------
      btnLoading: false,
      flag: false,
      typeIn: 'primary',
      checkFont: '入库',
      //
      order_details_type: 0, // 0.禁止修改，1.可修改
      hrefProData: {},
      //   --------------------
      itemTableBtnList: [],
      titleList: [
        {
          id: 1,
          name: '图片', // 必传
          value: 'baseImgUrl', // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: 'imageListAll', // 必传
          selectOptionKey: '', // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true, // 是否不可编辑，true可编辑，false不可编辑
          width: 80
        },
        {
          id: 0,
          name: '产品图纸',
          value: 'baseDrawingFile',
          fixedState: false,
          isShow: true,
          dataType: 'fileList',
          canEdit: false,
          width: 60
        },
        {
          id: 0,
          name: '产品附件',
          value: 'baseFileList',
          fixedState: false,
          isShow: true,
          dataType: 'fileList',
          canEdit: false,
          width: 60
        },
        {
          id: 0,
          name: '订单图片',
          value: 'valueImgList',
          fixedState: false,
          isShow: true,
          dataType: 'fileList',
          canEdit: false,
          width: 60
        },
        {
          id: 0,
          name: '订单附件',
          value: 'valueFileList',
          fixedState: false,
          isShow: true,
          dataType: 'fileList',
          canEdit: false,
          width: 60
        },
        {
          id: 0,
          name: '采购编号', // 必传
          value: 'purchaseOrderNumber', // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: 'text', // 必传
          selectOptionKey: '', // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: false, // 是否不可编辑，true可编辑，false不可编辑
          color: '#409eff',
          width: 115
        },
        {
          id: 1,
          name: '供应商名称',
          value: 'baseSupplierName',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 180
        },
        {
          id: 2,
          name: '产品编号',
          value: 'baseMaterialNumber',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 160
        },
        {
          id: 2,
          name: '产品名称',
          value: 'baseMaterialName',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 180
        },
        {
          id: 4,
          name: '单位',
          value: 'baseMaterialUnitName',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 60
        },
        {
          id: 3,
          name: '产品规格',
          value: 'specifications',
          fixedState: false,
          isShow: true,
          dataType: 'textList',
          canEdit: false,
          width: 240
        },
        {
          id: 4,
          name: '交期',
          value: 'baseReceiptDate',
          fixedState: false,
          isShow: true,
          dataType: 'dateTime',
          canEdit: false,
          width: 160
        },
        {
          id: 62,
          name: '本次入库数量',
          value: 'baseEntranceHomeAmount',
          fixedState: false,
          isShow: true,
          dataType: 'numberAccuracy',
          alwaysEditState: false,
          canEdit: false,
          width: 115
        },
        {
          id: 63,
          name: '已入库数量',
          value: 'valueReceiptAmount',
          fixedState: false,
          isShow: true,
          dataType: 'numberAccuracy',
          alwaysEditState: false,
          canEdit: false,
          width: 115
        },
        {
          id: 12,
          name: '采购人',
          value: 'basePurchaserName',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 115
        }
      ],
      dialogState: {
        show1: false,
        show2: false,
        show3: false,
        show4: false,
        show5: false
      },
      htmlDataDialogState: {
        show1: false,
        show2: false
      },
      globalSearchDialogData: {},
      // -----------------
      singleRowData: {},
      tableList: [],
      dialogType: 1,
      dialogStatus: 1,
      dialogTitle: '',
      markIndex: 1,
      // ---------------------------
      sysEntityDtoList: [],
      examineType: null,
      projectDetailsData: null,
      projectDetailsList: [],
      // 是否质检完成
      proddocTestDocShow: false,
      purchasesReceiptDocDetailId: 'tabs1',
      // 仓库数据
      storehouseList: [],
      storehouseListQuery: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      saleOrderList: [],
      salesOrderListQuery: {
        total: 0,
        pageNum: 1,
        pageSize: 20,
        mode: 0
      },
      purchaseOrderList: [],
      purchaseOrderListQuery: {
        total: 0,
        pageNum: 1,
        pageSize: 20,
        mode: 0
      },
      dialogData: {
        baseWarehouseWareId: null,
        baseWarehouseWareName: ''
      },
      batchNumberList: []
    };
  },
  created() {
    this.hrefProData = this.routeQuery;
    this.getList();
  },
  methods: {
    async getList() {
      await pmgtPurchasesReceiptDoc_cooperativeSupplierPurchasesReceiptDocView({
        purchasesReceiptDocId: this.hrefProData.purchasesReceiptDocId
      }).then((res) => {
        res.data.data.purchasesReceiptDocDetailList.forEach((item) => {
          // 处理子表
          item.unValueUnreceiptLockAmount = item.valueCanReceiptAmount;
          try {
            item.specifications = JSON.parse(item.baseMaterialSpecDesc);
          } catch (error) {
            item.specifications = [];
          }
        });
        this.itemList = res.data.data.purchasesReceiptDocDetailList;
        this.singleData = res.data.data;
        if (res.data.data.purchasesReceiptDocDetailList[0].valueReceiptAmount > 0) {
          this.typeIn = 'info';
          this.checkFont = '撤销入库';
        } else {
          this.typeIn = 'primary';
          this.checkFont = '入库';
        }
      });
    },
    customSelectDataShow(val, list) {
      if (list) {
        let single = list.filter((item) => {
          return item.value == val;
        });
        return single.length > 0 ? single[0].label : '';
      }
    },
    formatDate(time) {
      return this.$moment(time).format('YYYY-MM-DD'); // 获取当前时间
    },
    backHome() {
      this.$emit('backHome');
    },
    htmlDataDialogClose() {
      this.htmlDataDialogState.show1 = false;
      this.htmlDataDialogState.show2 = false;
      this.getList();
    },
    dialogClose() {
      this.btnLoading = false;
      this.dialogState = {
        show1: false,
        show2: false,
        show3: false,
        show4: false,
        show5: false
      };
    }
  }
};
</script>
<style scoped>
.span {
  margin-right: 20px;
  color: #1476c3;
}

.input {
  width: 100%;
}

.btnOne {
  background: #1476c3;
  color: white;
}

.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
  /* flex-direction: row ;
        justify-content:center; */
}

.title----font {
  color: #1476c3;
  position: relative;
  margin-left: 40%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}

.checkImg {
  height: 75px;
  width: 150px;
  position: absolute;
  top: 15px;
  right: 20px;
  z-index: 99;
  /* opacity: 0.5; */
  transform: rotate(-10deg);
}

.turnToPointer {
  cursor: pointer;
}

/* 页面修改样式 */
hr {
  border: none;
  border-top: solid 1px #dcdfe6;
}
.actionField {
  margin: 15px auto;
  padding-bottom: 8px;
}
.actionField label {
  color: #666;
}
::v-deep .vxe-table--render-default {
  border: none;
}
::v-deep .vxe-table--render-default.border--full th.vxe-header--column {
  border-bottom: 1px solid #dcdfe6 !important;
  border-left: 1px solid #dcdfe6 !important;
}
::v-deep .vxe-table--render-default.border--full .vxe-header--column {
  background-image: none;
}
::v-deep .vxe-table--render-default.border--full .vxe-body--column {
  background-image: none;
}
::v-deep .vxe-table--render-default.border--full .vxe-body--column {
  border-bottom: 1px solid #dcdfe6;
  border-left: 1px solid #dcdfe6;
}
</style>
